<script setup lang="ts">
import { SingleMetricReport } from '@dashhudson/dashing-ui/single-metric-report';
import { computed } from 'vue';

import type { MetricCardWidgetData } from '@/components/VisionAi/widgets/visionWidget.types.ts';

const props = withDefaults(
  defineProps<{
    widgetData: MetricCardWidgetData;
    narrowMode?: boolean;
  }>(),
  { narrowMode: false },
);

const channelGroups = computed(() => {
  if (!props.widgetData.channels?.length) return undefined;
  return {
    channels: props.widgetData.channels.map((channel) => ({ channel })),
  };
});

const reportAttributes = computed(() => {
  const {
    start_date: startDate,
    end_date: endDate,
    metric_time_frame: metricTimeFrame,
  } = props.widgetData;

  let customDateRange = undefined;
  if (startDate && endDate) {
    customDateRange = { start: new Date(startDate), end: new Date(endDate) };
  }

  return {
    customDateRange,
    metricTimeFrame,
  };
});

const singleMetricReportProps = computed(() => ({
  metricTitle: props.widgetData.title,
  value: props.widgetData.value,
  format: props.widgetData.format,
  // SingleMetricReport defaults currency to 'USD' when null/undefined
  // so we need to default to an empty string
  currency: props.widgetData.currency || '',
  channelGroups: channelGroups.value,
  reportAttributes: reportAttributes.value,
}));
</script>

<template>
  <SingleMetricReport v-bind="singleMetricReportProps" />
</template>
